import { GOCARDLESS } from "@/store/Gocardless/types";
export function setGocardless(context, payload) {
    context.commit(GOCARDLESS, payload);
}
export default {
    setGocardless,
};
